module.exports = __webpack_public_path__ + "img/woo.cc6f3592.png";